var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'bg-2': _vm.bgType == 2,
  },attrs:{"id":"app"}},[_c('router-view'),_c('portal-target',{staticClass:"portal",attrs:{"name":"modalPortal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }